/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React from "react";

type DeceasedInformationProps = {
    deceasedId: string,
    firstName: string,
    lastName: string,
    hebrewName: string,
    yahrzeitDateDisplay: string,
    yahrzeitDesc: string,
    gender: string,
    tribe: string,
    synagogueName: string,
    cemeteryName: string,
    locationNumber: string,
    birthDateDisplay: string,
    deathDateDisplay: string,
    deathDateJewish: string,
    burialDateDisplay: string,
    burialTimeDisplay: string,
    consecrationDateDisplay: string,
    consecrationTimeDisplay: string
}

export const DeceasedInformationDefault: React.FC<DeceasedInformationProps> = (props) => {
    return (

        <div className="card card-recent-funerals jc-border-12">
            <div className="card-header card-header-bg">
                <p className="jc-txt-heading fs-5">Information</p>
            </div>

            <div className="card-body p-0">
                <table className="table table-striped table-recent-funerals table-information mb-0">
                    <tbody>

                        <tr>
                            <td className="jc-txt-body fs-6">
                                <span className="fw-bold">Hebrew Death Date:</span><br/>
                                <span>{props.deathDateJewish ? props.deathDateJewish : "Unavailable"}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="jc-txt-body fs-6">
                                <span className="fw-bold">Hebrew Name:</span><br/>
                                <span>{props.hebrewName ? props.hebrewName : "Unavailable"}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="jc-txt-body fs-6">
                                <span className="fw-bold">Gender:</span><br/>
                                <span>{props.gender ? props.gender : "Unavailable"}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="jc-txt-body fs-6">
                                <span className="fw-bold">Tribe:</span><br/>
                                <span>{props.tribe ? props.tribe : "Unavailable"}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="jc-txt-body fs-6">
                                <span className="fw-bold">Synagogue:</span><br/>
                                <span>{props.synagogueName ? props.synagogueName : "Unavailable"}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="jc-txt-body fs-6">
                                <span className="fw-bold">Cemetery:</span><br/>
                                <span>{props.cemeteryName ? props.cemeteryName : "Unavailable"}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="jc-txt-body fs-6">
                                <span className="fw-bold">Grave:</span><br/>
                                <span>{props.locationNumber ? props.locationNumber : "Unavailable"}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="jc-txt-body fs-6">
                                <span className="fw-bold">Birth Date:</span><br/>
                                <span>{props.birthDateDisplay ? props.birthDateDisplay : "Unavailable"}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="jc-txt-body fs-6">
                                <span className="fw-bold">Death Date:</span><br/>
                                <span>{props.deathDateDisplay ? props.deathDateDisplay : "Unavailable"}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="jc-txt-body fs-6">
                                <span className="fw-bold">Burial Date:</span><br/>
                                <span>{props.burialDateDisplay ? props.burialDateDisplay : "Unavailable"}{props.burialTimeDisplay ? " • " + props.burialTimeDisplay : ""}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="jc-txt-body fs-6">
                                <span className="fw-bold">Consecration Date:</span><br/>
                                <span>{props.consecrationDateDisplay ? props.consecrationDateDisplay : "Unavailable"}</span>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    );
}